import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Megapark from "../../assets/images/megapark.png";

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* ÜST BEYAZ KART (Logo + Slogan + Sosyal) */}
      <div className="slogan-banner">
        <Container>
          <div className="slogan-card">
            <div className="logo">
              <Link to="/" onClick={scrollToTop}><img src={Megapark} alt="Megapark Hospital" height={50} /></Link>
            </div>
            <p className="slogan-text">
              Daha Sağlıklı Yarınlar <span>İçin</span>
            </p>
            <div className="social-icons">
              <Link target="_blank" rel="noopener noreferrer" to="https://www.facebook.com/" aria-label="Facebook" className="social-icon"><i className="bi bi-facebook" /></Link>
              <Link target="_blank" rel="noopener noreferrer" to="https://twitter.com/" aria-label="Twitter" className="social-icon"><i className="bi bi-twitter" /></Link>
              <Link target="_blank" rel="noopener noreferrer" to="https://www.instagram.com/megaparkhastanesi/reels/" aria-label="Instagram" className="social-icon"><i className="bi bi-instagram" /></Link>
              <Link target="_blank" rel="noopener noreferrer" to="https://www.linkedin.com/" aria-label="LinkedIn" className="social-icon"><i className="bi bi-linkedin" /></Link>
              <Link target="_blank" rel="noopener noreferrer" to="https://www.youtube.com/" aria-label="YouTube" className="social-icon"><i className="bi bi-youtube" /></Link>
            </div>
          </div>
        </Container>
      </div>

      {/* ANA KIRMIZI ALAN */}
      <footer className="footer">
        <div className="phone-row">
          <Container>
            <h6 className="phone-number">(0344) 231 62 62</h6>
            <h6 className="phone-number">444 46 00</h6>

          </Container>
        </div>

        <div className="menu-row">
          <Container>
            <div className="menu-grid">
              <div className="menu-aside">
                <Link to="/" className="menu-head" onClick={scrollToTop}>Anasayfa</Link>
                <Link to="/hekimler" className="menu-head" onClick={scrollToTop}>Hekimler</Link>
                <Link to="/is-basvurusu" className="menu-head" onClick={scrollToTop}>İş Başvurusu</Link>
              </div>

              <div className="menu-blocks">
                <div className="menu-links">
                  <Link to="/hakkimizda" className="nav-link" onClick={scrollToTop}>Hakkımızda</Link>
                  <Link to="/vizyon-misyon" className="nav-link" onClick={scrollToTop}>Vizyon &amp; Misyon</Link>
                  <Link to="/kvkk" className="nav-link" onClick={scrollToTop}>KVKK</Link>
                  <Link to="/tibbi-birimler" className="nav-link" onClick={scrollToTop}>Tıbbi Birimler</Link>
                  <Link to="/hasta-haklari-bildirgesi" className="nav-link" onClick={scrollToTop}>Hasta Hakları Bildirgesi</Link>
                  {/* <Link to="/saglik-bulteni" className="nav-link" onClick={scrollToTop}>Sağlık Bülteni</Link> */}
                  {/* <Link to="/haberler" className="nav-link" onClick={scrollToTop}>Haberler</Link> */}
                  {/* <Link to="/bilgi-toplumu-hizmetleri" className="nav-link" onClick={scrollToTop}>Bilgi Toplum Hizmetleri</Link> */}
                </div>
                <div className="menu-links">
                  <Link to="/hasta-memnuniyet-anketleri" className="nav-link" onClick={scrollToTop}>Hasta Memnuniyeti Anketleri</Link>
                  <Link to="/hastane-calisanlari-gorus-ve-oneri-formu" className="nav-link" onClick={scrollToTop}>Çalışan Görüş ve Önerileri</Link>
                  <Link to="/istenmeyen-olay" className="nav-link" onClick={scrollToTop}>İstenmeyen Olay Bildirimi</Link>
                  <Link to="/sosyal-hizmet-birimi-hasta-gorusme-formu" className="nav-link" onClick={scrollToTop}>Sosyal Hizmet Birimi</Link>
                  <Link to="/duzenleyici-onleyici-faaliyet-talep-formu" className="nav-link" onClick={scrollToTop}>DÖF Talep Formu</Link>
                </div>
              </div>

              <div className="contact-box">
                <div className="contact-icon"><i className="bi bi-phone" /></div>
                <div className="contact-text">7/24 YANINIZDAYIZ</div>
              </div>
            </div>
          </Container>
        </div>

        <div className="copyright">
          <Container>
            <div className="copy-inner">HG Holding © 2025</div>
          </Container>
        </div>
      </footer>
    </>
  );
};

export default Footer;

